import { render } from "./Message.vue?vue&type=template&id=3b9f7478&scoped=true"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"

import "./Message.vue?vue&type=style&index=0&id=3b9f7478&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3b9f7478"

export default script